# The site menu: the top bar on tablets and desktops, the hamburger drawer on
# phones. Each one hides itself at the other breakpoint.
tag site-nav
	prop selected\string = ""

	<self>
		<nav-topbar selected=selected>
		<nav-drawer selected=selected>
